import { useState, useContext, createContext } from "react";

export const AuthContext = createContext({
  user: null,
  isTempPwd: null,
  token: null,
  passwordReset: false,
  setUser: () => {},
  setToken: () => {},
  setUserRole: () => {},
  setDarkMode: () => {},
  setIsTempPwd: () => {},
  setPasswordReset: false,
  session: "",
  darkMode: false,
  setSession: "",
  sessionCount: "",
  setSessionCount: "",
  userRole: "",
});

export const ContextProvider = ({ children }) => {
  const [user, _setUser] = useState({});
  const [token, _setToken] = useState(localStorage.getItem("token"));
  const [userRole, _setUserRole] = useState(localStorage.getItem("userRole"));
  const [darkMode, _setDarkMode] = useState(
    JSON.parse(localStorage.getItem("darkMode")),
  );
  const [isTempPwd, _setIsTempPwd] = useState(
    localStorage.getItem("isTempPwd"),
  );
  const [session, _setSession] = useState(localStorage.getItem("session"));
  const [sessionCount, _setSessionCount] = useState(
    localStorage.getItem("sessionCount"),
  );
  const [passwordReset, _setPasswordReset] = useState(
    localStorage.getItem("reset_state"),
  );

  const setUser = (user) => {
    _setUser(user);
    if (user) {
      localStorage.setItem("user", JSON.stringify(user));
    } else {
      localStorage.removeItem("user");
    }
  };
  const setDarkMode = (mode) => {
    _setDarkMode(mode);
    if (mode) {
      localStorage.setItem("darkMode", JSON.stringify(mode));
    } else {
      localStorage.removeItem("darkMode");
    }
  };
  const setToken = (token) => {
    _setToken(token);
    if (token) {
      localStorage.setItem("token", token);
    } else {
      localStorage.removeItem("token");
    }
  };

  const setUserRole = (role) => {
    _setUserRole(role);
    if (role) {
      localStorage.setItem("userRole", role);
    } else {
      localStorage.removeItem("userRole");
    }
  };

  const setIsTempPwd = (boolValue) => {
    _setIsTempPwd(boolValue);
    if (boolValue) {
      localStorage.setItem("isTempPwd", boolValue);
    } else {
      localStorage.removeItem("isTempPwd");
    }
  };
  const setSession = (sessionToken) => {
    _setSession(sessionToken);
    if (sessionToken) {
      localStorage.setItem("session", sessionToken);
    } else {
      localStorage.removeItem("session");
    }
  };
  const setSessionCount = (count) => {
    _setSessionCount(count);
    if (count) {
      localStorage.setItem("sessionCount", count);
    } else {
      localStorage.removeItem("sessionCount");
    }
  };
  const setPasswordReset = (state) => {
    _setPasswordReset(state);
    if (state) {
      localStorage.setItem("reset_state", state);
    } else {
      localStorage.removeItem("reset_state");
    }
  };
  return (
    <AuthContext.Provider
      value={{
        user,
        isTempPwd,
        token,
        setUser,
        darkMode,
        setDarkMode,
        setIsTempPwd,
        setToken,
        passwordReset,
        setPasswordReset,
        session,
        setSession,
        sessionCount,
        setSessionCount,
        setUserRole,
        userRole,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const UserStateContext = () => useContext(AuthContext);

